
import { defineComponent, onMounted, ref, watch, reactive } from "vue";
import { Image, Steps, Step, Button, Popup, Dialog } from "vant";
import Account from "@/api/account";
import dayjs from "dayjs";

export default defineComponent({
  name: "DetailvueApproval",
  props: {
    approveInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return { show: false };
  },
  components: {
    "van-image": Image,
    "van-step": Step,
    "van-steps": Steps,
    "van-button": Button,
    "van-popups": Popup,
  },
  setup(props, ctx) {
    const visitor_name = ref("");
    const user_count = ref("");
    const visitor_tel = ref("");
    const approve_photo = ref("");
    const visitor_reason = ref("");
    const touser_name = ref("");
    const visitor_in_time = ref("");
    const approve_status = ref("");
    const status = ref(0);
    const id = ref("");
    const approve_user_id = ref("");
    const approvalData = ref<any>({});
    const stateMap = ref<any>({
      InApproval: '待审批',
      ApprovalPassed: '审批通过',
      ApprovalAborted: '审批拒绝',
    });
    const currentIndex = ref(0);
    const dicMap = ref<any>({});
    const dicData = [
      {
        code_item_id: "0",
        code_item_name: "请假申请",
      },
      {
        code_item_id: "7",
        code_item_name: "审批中",
      },
      {
        code_item_id: "9",
        code_item_name: "请假录入",
      },
      {
        code_item_id: "8",
        code_item_name: "已撤销",
      },
      {
        code_item_id: "2",
        code_item_name: "审批拒绝",
      },
      {
        code_item_id: "3",
        code_item_name: "撤销申请",
      },
      {
        code_item_id: "4",
        code_item_name: "审批通过",
      },
      {
        code_item_id: "5",
        code_item_name: "审批拒绝",
      },
      {
        code_item_id: "6",
        code_item_name: "审批已阅",
      },
      {
        code_item_id: "10",
        code_item_name: "返校审批中",
      },
      {
        code_item_id: "11",
        code_item_name: "返校通过",
      },
      {
        code_item_id: "12",
        code_item_name: "返校拒绝",
      },
      {
        code_item_id: "1",
        code_item_name: "审批通过",
      },
    ];
    dicData.forEach((item) => {
      dicMap.value[item.code_item_id] = item.code_item_name;
    })
    //const envs = ref('https://res-mal.12kcool.com/')
    const envs = ref("https://res-k12.12kcool.com/");
    const setApprove = (status?: number) => {
      let approvalId = "";
      const params = {
        approve_user_id: approve_user_id.value,
      };
      if (!status) {
        approvalId = "-1";
      }
      Dialog.confirm({
        title: "提示",
        message: `确定要${status === 2 ? "同意" : "拒绝"}吗？`,
      })
        .then(async () => {
          // on confirm
          const [err, data] = await Account.setApprove(
            approvalId || id.value,
            status,
            params
          );
          ctx.emit('refresh');
          console.log(data);
        })
        .catch(() => {
          // on cancel
        });
    };
    const setid = async (ids: any) => {
      id.value = ids;
    };
    const setVisitorId = async (ids: any) => {
      approve_user_id.value = ids;
    };

    const getstatus = (statu: number) => {
      let val = "";
      if (statu === 0) {
        val = "待审批";
      } else if (statu === 1) {
        val = "审批拒绝";
      } else {
        val = "审批通过";
      }
      return val;
    };
    watch(
      () => props.approveInfo,
      (val) => {
        console.log("approveInfo", val);
        const data = val || {};
        approvalData.value = data.approve_data?.approval || {};
        if (approvalData.value.groups) {
					if (approvalData.value.state === 'InApproval') {
						const index = approvalData.value.groups.findIndex(
              (item: any) => item.id === approvalData.value.current_group
            );
            currentIndex.value = index === -1 ? 0 : index;
					} else {
						currentIndex.value = approvalData.value.groups?.length - 1 || 0
					}
        } else {
          currentIndex.value =  0
        }
        visitor_name.value = data.visitor_name;
        user_count.value = data.user_count;
        visitor_tel.value = data.visitor_tel;
        approve_photo.value = data.approve_photo;
        visitor_reason.value = data.visitor_info.visitor_reason;
        touser_name.value = data.visitor_info.touser_name;
        visitor_in_time.value = dayjs(data.visitor_in_time).format(
          "YYYY-MM-DD HH:mm"
        );
        approve_status.value = getstatus(data.visitor_info.approve_status);
        status.value = data.visitor_info.approve_status;
      },
      {
        deep: true,
        immediate: true,
      }
    );
    onMounted(async () => {
      // Notify('onMounteSSSd')
    });

    return {
      envs,
      visitor_name,
      user_count,
      visitor_tel,
      approve_photo,
      visitor_reason,
      touser_name,
      visitor_in_time,
      approve_status,
      status,
      setApprove,
      setid,
      setVisitorId,
      id,
      approve_user_id,
      approvalData,
      stateMap,
      currentIndex,
      dicMap,
      dayjs
    };
  },
  created() {
    console.log("query", this.$route.query);
    this.setid(this.$route.query.touser_id);
    this.setVisitorId(this.$route.query.approve_user_id);
  },
});
